const BotState = {
    botId : 0,
    botName : '',
    companyId : 0,
    errors : [],
    code : '',
    phone : '',
    blockStart : {},
    variables : [],
    onUpdate : false,
}

export default BotState